import React from "react";
import Axios from "axios";
import * as Constants from "../../consts/Constants.js";
import Scheduler, { AppointmentDragging } from "devextreme-react/scheduler";
import Draggable from "devextreme-react/draggable";
import ScrollView from "devextreme-react/scroll-view";
import * as ScreenText from "../../consts/ScreenText.js";
import "../../styles/css/StylePharmacy.css";
import { locale, loadMessages } from "devextreme/localization";

const currentDate = new Date();
const views = [{ type: "month", intervalCount: 1 }];
const draggingGroupName = "appointmentsGroup";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      business: [],
      appointments: [],
    };
    this.onAppointmentRemove = this.onAppointmentRemove.bind(this);
    this.onAppointmentAdd = this.onAppointmentAdd.bind(this);
    this.onAppointmentDblClick = this.onAppointmentDblClick.bind(this);
    this.onAppointmentUpdating = this.onAppointmentUpdating.bind(this);
    loadMessages({
      en: { "dxScheduler-switcherMonth": "Mes" },
    });
    locale("es");
  }

  componentDidMount() {
    this.getItems();
    this.getAppointments();
  }

  render() {
    const { business, appointments } = this.state;
    return (
      <React.Fragment>
        <div className="pharmacy">
          <div className="title">{ScreenText.PHARMACY_TITLE}</div>
          <div className="body">
            <ScrollView classname="listItems" id="scroll">
              <Draggable
                id="list"
                classname="listItems"
                data="dropArea"
                group={draggingGroupName}
                onDragStart={this.onListDragStart}
              >
                {business.map((item) => {
                  return (
                    <Draggable
                      key={item.id}
                      className="item dx-card dx-theme-text-color dx-theme-background-color"
                      clone={true}
                      group={draggingGroupName}
                      data={item}
                      onDragStart={this.onItemDragStart}
                      onDragEnd={this.onItemDragEnd}
                    >
                      {item.text}
                    </Draggable>
                  );
                })}
              </Draggable>
            </ScrollView>
            <Scheduler
              id="scheduler"
              dataSource={appointments}
              defaultCurrentView="month"
              views={views}
              editing={{
                allowAdding: false,
                allowDeleting: true,
                allowDragging: true,
                allowResizing: false,
                allowTimeZoneEditing: false,
                allowUpdating: true,
              }}
              defaultCurrentDate={currentDate}
              onAppointmentRemove={this.onAppointmentRemove}
              onAppointmentDblClick={this.onAppointmentDblClick}
              onAppointmentDeleted={this.onAppointmentRemove}
              onAppointmentUpdating={this.onAppointmentUpdating}
            >
              <AppointmentDragging
                onRemove={this.onAppointmentRemove}
                group={draggingGroupName}
                onAdd={this.onAppointmentAdd}
              />
            </Scheduler>
          </div>
          <div className="info"> {ScreenText.PHARMACY_MESSAGE}</div>
        </div>
      </React.Fragment>
    );
  }

  getAppointments() {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_ON_DUTY, {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((appointment) => {
          data.push({
            text: appointment.name,
            id: appointment.businessId,
            startDate: new Date(appointment.date),
            allDay: true,
          });
        });
        this.setState({ appointments: data });
      })
      .catch(function (thrown) {});
    return () => source.cancel();
  }

  getItems() {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_BUSINESS, {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((item) => {
          if (item.category === Constants.CATEGORY_PHARMACY)
            data.push({ text: item.name, id: item.id });
        });
        this.setState({ business: data });
      })
      .catch(function (thrown) {});
    return () => source.cancel();
  }

  onAppointmentDblClick(e) {
    e.cancel = true;
  }

  onAppointmentRemove(e) {
    let businessId = e.appointmentData.id;
    let date = new Date(e.appointmentData.startDate).getTime();

    Axios.delete(Constants.FINAL_URL_ON_DUTY + businessId + "/" + date)
      .then((response) => {
        this.setState({
          business: [...this.state.business],
          appointments: [...this.state.appointments],
        });
      })
      .catch(function (thrown) {});
  }

  onAppointmentAdd(e) {
    const index = this.state.business.indexOf(e.fromData);
    if (index >= 0) {
      this.state.appointments.push({ ...e.itemData, allDay: true });

      const newAppointment = {
        businessId: e.itemData.id,
        date: new Date(e.itemData.startDate).getTime(),
      };
      Axios.post(Constants.FINAL_URL_ON_DUTY, newAppointment)
        .then((response) => {
          if (response.status === 201)
            this.setState({
              appointments: [...this.state.appointments],
            });
        })
        .catch(function (thrown) {});
    }
  }

  onAppointmentUpdating(e) {
    const oldAppointment = {
      businessId: e.oldData.id,
      date: new Date(e.oldData.startDate).getTime(),
    };
    const newAppointment = {
      businessId: e.newData.id,
      date: new Date(e.newData.startDate).getTime(),
    };

    Axios.put(
      Constants.FINAL_URL_ON_DUTY +
        oldAppointment.businessId +
        "/" +
        oldAppointment.date,
      newAppointment
    )
      .then((response) => {
        this.state.appointments.push({ ...e.itemData, allDay: true });
        this.setState({
          appointments: [...this.state.appointments],
        });
      })
      .catch(function (thrown) {});
  }

  onListDragStart(e) {
    e.cancel = true;
  }

  onItemDragStart(e) {
    e.itemData = e.fromData;
  }

  onItemDragEnd(e) {
    if (e.toData) {
      e.cancel = true;
    }
  }
}

export default App;
